
































































































































































import { Component, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import BaseItemsPage from "../BaseItemsPage";
import {GroupIncomingItem} from "@/store/statistics/types";
import GroupCharts from "@/components/Statistics/GroupCharts.vue";
import {ScrollButton} from "wings-ui-components";
import GroupIncomingFilter from "@/components/Statistics/GroupIncomingFilter.vue";
import { MsgTransports } from "@/store/types";

@Component({
  components: { GroupIncomingFilter, ScrollButton, GroupCharts },
})
export default class GroupIncoming extends BaseItemsPage<GroupIncomingItem> {
  @Prop() transport!: MsgTransports;
  @Getter("statisticGroupIncoming") responseItems!: GroupIncomingItem[];
  @Action("resetStatisticDetailIncomingState") resetStatisticDetailIncomingState: any;
  @Getter("incomingGroupBy") groupByList: any;
  @Getter("incomingGroupByOptionally") groupByOptionallyList: any;

  is_show_filter = true;
  is_show_graphics = true;
  currentSort = "date";

  tableFields = this.tableFieldsDefault;

  group_by = '';
  optionally_group_by = '';

  get tableFieldsDefault() {
    return ["processed", "error", "total"];
  }

  onGroupByChange(data: any) {
    this.group_by = data.groupBy
    this.optionally_group_by = data.optionallyGroupBy
  }

  print(item: string, totalRow: boolean) {
    if (totalRow) return this.group_by ? '' : this.$t('inAll');
    return item ?? this.$t('unnamed')
  }

  getData() {
    return this.responseItems;
  }

  get totalData(): any {
    let total = {
      totalRow: "This is the last row of the table",
      processed: 0,
      error: 0,
      total: 0,
    };

    this.tableData.forEach((row) => {
      total.processed += row.processed;
      total.error += row.error;
      total.total += row.total;
    });
    return total;
  }

  get campareData(): any[] {
    return [...this.queriedData, this.totalData];
  }

  beforeDestroy() {
    this.resetStatisticDetailIncomingState();
  }
}
